import React, { Component } from 'react';
import {ApiBaseUrl, GoogleMapUrl, GoogleMapKey, SilverbackPhone, SilverbackName} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import Moment from 'react-moment';
import { trackPromise } from 'react-promise-tracker';
import ShowMoreText from 'react-show-more-text';
import {withSnackbar} from "react-simple-snackbar";

class EntryPass extends Component{
    static contextType = AuthContext;
    state = {
        data:{
            club : {
                companyname: ''
            },
            staff : {
                name : '',
                phone : ''
            },
            badges : []
        },
        user: {}
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/entry_pass/",
                {
                    method: 'POST',
                    body: 'id='+this.props.match.params.id,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(!result.success)
                            this.props.openSnackbar(result.message)
                        else
                            this.setState({
                                data: result.data
                            });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/profile",
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else
                        this.setState({
                            user: result.data
                        });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render(){
        return(
            this.state.data.name ?
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="entry-pass-outer-alt">
                        <p className="entry-pass--title">{this.state.data.category ? this.state.data.category.name : null}</p>
                        <div className="person-entrypass-outer">
                            <div className="row">
                                <div className="col-lg-6 mx-auto px--xs-0">
                                    <div className="bor-mob-pass">
                                        <span className="cut-img-af"></span>

                                        {this.state.data.invoice && <a rel="noopener noreferrer" href={this.state.data.invoice} target="_blank"><button type="button" className="receipt-entrypass">Receipt</button></a>}

                                        <div className="person-entrypass-proile-image">
                                            <img src={this.state.user.image} alt={this.state.user.name}/>
                                        </div>
                                        <div className="person-entrypass-proile-desc">
                                            <p><span className="proile-label">Name :</span> <span
                                                className="proile-name">{this.state.user.name}</span></p>
                                            <p><span className="proile-label">Date : </span><span><i
                                                className="fa fa-calendar" aria-hidden="true"></i>
      <Moment format="DD MMMM YYYY" parse="DD-MM-YYYY">
                                            {this.state.data.purchased_for_date}
                                        </Moment></span></p>
                                            <p><span className="proile-label">For :</span> <span><i
                                                className="fa fa-user" aria-hidden="true"></i> {this.state.data.consumer_admission_capacity_male} Person</span></p>
                                            <p><span className="proile-label">Email : </span><span><i
                                                className="fa fa-envelope-o" aria-hidden="true"></i>
                                                {this.state.user.email}</span></p>
                                            <p><span className="proile-label">Phone : </span><span><i
                                                className="fa fa-phone" aria-hidden="true"></i>
                                                {this.state.user.phone}</span></p>
                                            <p><span className="proile-label">Deal Id : </span><span><i
                                                className="fa fa-handshake-o" aria-hidden="true"></i>
                                                {this.state.data._id}</span></p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 px--xs-0 mt-3 text-center text-md-center">
                                    <div className="person-entrypass-ticketvalid">
                                        <p className="mb-0">This ticket is only valid on <Moment format="DD MMMM YYYY" parse="DD-MM-YYYY">
                                            {this.state.data.purchased_for_date}
                                        </Moment></p>
                                    </div>
                                </div>
                                <div className="col-md-12 px--xs-0">
                                    <p className="mb-3 reedemed-head">
                                        {this.state.data.is_redeemed ?
                                            <span
                                                className="text-success-alt font-weight-bold">Redeemed</span>
                                            :
                                            <span
                                                className="text-danger-alt font-weight-bold">Not Redeemed</span>
                                        }
                                    </p>
                                    <p className="mb-3 text-white bg-2a p-xl-3 p-2 d-block text-center"><strong
                                        className="text-note">Note :</strong> Congratulations! You have successfully paid in full for this deal!<br/> If you want a full VIP hosted experience at an <b>extra cost</b> please contact {SilverbackName} <b> {SilverbackPhone}</b></p>

                                    <div className="entrypass-pp-main">
                                        <div className="row">
                                            <div className="col-md-12 col-lg-6">
                                                <div className="bg-2a bg-block">
                                                    <h4 className="event-title mb-0 text-note">{this.state.data.name}</h4>
                                                    <p className="entrypass-list-item mt-3">{this.state.data.subtitle}</p>
                                                    <p className="event-address mt-4 pl-4"><span><i
                                                        className="fa  fa-map-marker"></i></span>{this.state.data.companyaddress}</p>
                                                </div>
                                                {this.state.data.shared_by &&
                                                <div className="item-box">
         <span>
            <img src={this.state.data.shared_by.image} alt={this.state.data.shared_by.name}/>
         </span>
                                                    <div className="content">
                                                        <h5 className="font-weight-bold">Host : {this.state.data.shared_by.name}</h5>
                                                        <ul>
                                                            <li><span><i className="fa fa-envelope"></i></span>{this.state.data.shared_by.email}
                                                            </li>
                                                            <li><span><i className="fa fa-phone"></i></span>{this.state.data.shared_by.phone}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                            <div className="col-md-12 col-lg-6">
                                                <div className="entry-pass-event-detail">
                                                    {this.state.data.poc_name || this.state.data.poc_phone ?
                                                        <p className="event-address my-3 font-weight-bold point-of-contact">
                                                            <span><i className="fa  fa-user-o"></i></span>
                                                            <span className="">Point of contact - </span> {this.state.data.poc_name && <span
                                                            className="text-danger-alt">{this.state.data.poc_name}</span>}
                                                            {this.state.data.poc_phone && <a href={'tel:' + this.state.data.poc_phone}
                                                               className="d-inline-block pl-3 position-relative"><i
                                                                className="fa fa-phone-square position-relative"></i></a>}
                                                        </p> : null
                                                    }
                                                    <p className="event-address mt-4 font-weight-bold point-of-contact">
                                                        <span><i className="fa fa-clock-o"></i></span>Event time - <span
                                                        className="text-note">
												{this.state.data.starttime ? this.state.data.starttime : 'None'}
											</span>
                                                    </p>
                                                    <p className="event-address mt-4 font-weight-bold point-of-contact">
                                                        <span><i className="fa fa-clock-o"></i></span>Business Hours
                                                        - <span className="text-note">
												{this.state.data.businessstarttime ? this.state.data.businessstarttime : 'None'}
											</span>
                                                    </p>
                                                    <p className="event-address mt-4 font-weight-bold point-of-contact">
                                                        <span><i className="fa fa-usd" aria-hidden="true"></i></span>Order
                                                        Cost - <span className="text-note">
												${this.state.data.consumer_order_cost}
											</span>
                                                    </p>
                                                    <p className="event-address mt-4 font-weight-bold point-of-contact">
                                                        <span><i className="fa fa-usd" aria-hidden="true"></i></span>Complete
                                                        Payment done - <span className="text-note">
												${this.state.data.consumer_order_cost}
											</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="entrypass-bottom-detail">
                                        <div className="row align-items-start flex-row-reverse">
                                            <div className="col-md-6">
                                                <div className="deal-detail-main info-inline">
                                                    <div className="full_Width">
                                                        <p className="label font-weight-bold"><i
                                                            className="fa fa-building-o" aria-hidden="true"></i>About
                                                            the company</p>
                                                        <div className="label_info more"><ShowMoreText
                                                            /* Default options */
                                                            lines={3}
                                                            more='Show more'
                                                            less='Show less'
                                                            anchorClass='morelink'
                                                            expanded={false}
                                                        >{this.state.data.aboutcompany}</ShowMoreText></div>
                                                    </div>
                                                </div>
                                                <div className="deal-detail-main">
                                                    <p className="label color-60f font-weight-bold">
                                                        <i className="fa fa-list-alt" aria-hidden="true"></i>
                                                        Deal Detail(s)
                                                    </p>
                                                    <div className="label_info more"><strong><ShowMoreText
                                                        /* Default options */
                                                        lines={3}
                                                        more='Show more'
                                                        less='Show less'
                                                        anchorClass='morelink'
                                                        expanded={false}
                                                    >{this.state.data.description}</ShowMoreText></strong></div>

                                                </div>
                                                <div className="deal-detail-main info-inline">
                                                    <div className="full_Width">
                                                        <p className="label color-60f font-weight-bold"><i
                                                            className="fa fa-check" aria-hidden="true"></i>Deal Rules
                                                        </p>
                                                        <div className="label_info more"><strong><ShowMoreText
                                                            /* Default options */
                                                            lines={3}
                                                            more='Show more'
                                                            less='Show less'
                                                            anchorClass='morelink'
                                                            expanded={false}
                                                        >{this.state.data.rule}</ShowMoreText></strong></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="map_container">
                                                    <h4 className="location-direction-heading green-color mt-0"><span><i
                                                        className="fa  fa-map-marker"></i></span>Location (Directions)
                                                    </h4>
                                                    <div className="map-location-outer">
                                                        <div style={{ height: '320px', width: '100%' }}>
                                                            {this.state.data.location &&
                                                            <iframe title="map" width="100%" height="300" frameBorder="0"
                                                                    style={{border: "0"}}
                                                                    src={ GoogleMapUrl+ this.state.data.location.coordinates[1] + ',' + this.state.data.location.coordinates[0] + '&key=' + GoogleMapKey}></iframe>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.data.invoice &&
                        <div className="entrypass-receipt d-lg-none d-xl-none">
                            <a rel="noopener noreferrer" href={this.state.data.invoice} target="_blank">
                                <button type="button" className="grad-on rct--btn">Receipt</button>
                            </a>
                        </div>
                        }
                    </div>
                </div>
            </div> : null
        )
    }
}

export default withSnackbar(EntryPass,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});